import { Alert, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { useNumbers } from 'ui/components/utils/useNumbers'
import {
  BuyAndWinBenefitVariant,
  BuyAndWinEffect,
  MaxPriceKeys,
} from '../../../../../typings'
import { messages } from '../messages'

export function BuyAndWinRecap(props: { buyAndWin: BuyAndWinEffect }) {
  const {
    buyAndWin: { trigger, benefit },
  } = props

  const { formatCurrency } = useNumbers()

  return (
    <Alert variant="info">
      <FormattedMessage
        {...messages.buyAndWin.recap}
        values={{
          buyMinCount: trigger?.minQuantity,
          benefit: benefit?.type,
          maxPrice:
            benefit?.type ===
              BuyAndWinBenefitVariant.MAXIMUM_UNIT_PRICE_DISCOUNT &&
            formatCurrency(benefit[MaxPriceKeys.price]),
          b: (content) => <Text variant="action1">{content}</Text>,
        }}
      />
    </Alert>
  )
}
